"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HealthSubCategory = void 0;
const type_utils_1 = require("@transcend-io/type-utils");
/** Information about an individual's health */
exports.HealthSubCategory = (0, type_utils_1.makeEnum)({
    /** Fallback subcategory */
    Health: 'HEALTH',
});
//# sourceMappingURL=health.js.map